interface IdleDeadline {
  didTimeout: boolean;
  timeRemaining(): number;
}

window.requestIdleCallback =
  window.requestIdleCallback ||
  function (cb: (deadline: IdleDeadline) => void): number {
    const start = Date.now();
    return setTimeout(function () {
      cb({
        didTimeout: false,
        timeRemaining: function (): number {
          return Math.max(0, 50 - (Date.now() - start));
        },
      });
    }, 1) as unknown as number;
  };

window.cancelIdleCallback =
  window.cancelIdleCallback ||
  function (id: number): void {
    clearTimeout(id);
  };

export {};
